var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement } from "react";
import classNames from "classnames";
import { SidebarHeader } from "./components/SidebarHeader";
import { SidebarContent } from "./components/SidebarContent";
import { SidebarFooter } from "./components/SidebarFooter";
// styles
import "./sidebar.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-sidebar",
    position: "right",
    type: "shrinkable",
};
/**
 * A panel which slides in from the edge of the screen.
 */
const Sidebar = (_a) => {
    var { className, position, width, height, children, isOpen, onToggle, type, onBackdropClick } = _a, rest = __rest(_a, ["className", "position", "width", "height", "children", "isOpen", "onToggle", "type", "onBackdropClick"]);
    const classList = classNames("tecma-sidebar", position && `tecma-sidebar-${position}`, { isOpen }, className);
    const containerClassList = classNames("tecma-sidebar-container", position && `tecma-sidebar-container-${position}`, { [`${type}`]: type }, { isOpen });
    const widthStyle = width && { width: `${width}rem` };
    const heightStyle = height && { height: `${height}rem` };
    return (_jsx("div", { className: containerClassList, onClick: isOpen ? onBackdropClick : undefined, role: "presentation", children: _jsx("div", Object.assign({ className: classList, style: Object.assign(Object.assign({}, widthStyle), heightStyle) }, rest, { children: Children.map(children, (child) => cloneElement(child, { isOpen, onToggle, position })) })) }));
};
Sidebar.defaultProps = defaultProps;
const SidebarComponent = Object.assign(Sidebar, {
    Header: SidebarHeader,
    Content: SidebarContent,
    Footer: SidebarFooter,
});
export { SidebarComponent as Sidebar };
